import React, { useEffect, useState } from "react";
import { trackButtonClick, parseCurrentUriAds } from "../tracking/tracker";

export const Navigation = (props) => {
    const [links, setLinks] = useState({
    mycard: "/mycard"
  });
  useEffect(() => {
    const { ads, ref } = parseCurrentUriAds();

    if (ads || ref) {
      setLinks((prevLinks) => {
        const updated = {};

        Object.keys(prevLinks).forEach((key) => {
          let url;

          try {
            // 如果是完整網址
            url = new URL(prevLinks[key]);
          } catch (e) {
            // 如果是相對路徑，補上 origin
            url = new URL(prevLinks[key], window.location.origin);
          }

          // 分開 set → 不會被 encode 成怪字串
          if (ads) url.searchParams.set("_ads", ads);
          if (ref) url.searchParams.set("ref", ref);

          updated[key] = url.toString();
        });

        return updated;
      });
    }
  }, [props.data]); // 當 props.data 改變時更新連結

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
            <img src="../img/logo.png" alt="logo" className="logo-img" />
          </a>{" "}
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#newbie" className="page-scroll nav-point">
                新手大禮包
              </a>
            </li>
            <li>
              <a href="#level" className="page-scroll nav-point">
                全新等級制度
              </a>
            </li>
            <li>
              <a href="#friends" className="page-scroll nav-point">
                推薦好友回饋
              </a>
            </li>
            <li>
              <a href="#hotgame" className="page-scroll">
                熱門遊戲
              </a>
            </li>
            {/* <li>
              <a href="#swiper" className="page-scroll">
                精選活動
              </a>
            </li> */}
            <li>
              <a href="#feature" className="page-scroll">
                六大特色
              </a>
            </li>
            <li>
              <a href={links.mycard} className="page-scroll" target="blank">
                MyCard限定優惠
              </a>
            </li>
            <li>
              <a href="#shortcut" className="page-scroll">
                捷徑教學
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
